<template>
  <input
    class="DateInput"
    type="number"
    :class="modifiers"
    :value="value"
    @input="update"
    @blur="pad"
  />
</template>

<script>
export default {
  props: {
    value: String,
    day: {
      type: Boolean,
      default: false,
    },
    month: {
      type: Boolean,
      default: false,
    },
    year: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      const { $props } = this;
      const cssClasses = [];
      if ($props.day) cssClasses.push("DateInput--day");
      if ($props.month) cssClasses.push("DateInput--month");
      if ($props.year) cssClasses.push("DateInput--year");
      return cssClasses.join(" ");
    },
  },
  methods: {
    update(ev) {
      const { value } = ev.target;
      const cappedValue = value.slice(0, 2);
      this.$emit("input", cappedValue);
      if (value.length > 2) this.$forceUpdate();
      if (value.length == 2) this.$nextTick(() => this.$emit("filled"));
    },
    pad() {
      const { $props } = this;
      if ($props.value) {
        const paddedValue = $props.value.padStart(2, "0");
        this.$emit("input", paddedValue);
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import './DateInput.styl';
</style>
